/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";

import { header } from "../../../../../components/api/Header";
import PieChart2 from "../../../../../components/Charts/PieChart2";
import BarChart5 from "../../../../../components/Charts/BarChart5";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Page1({ date }) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/amudaryo/graph?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  if (loading) {
    return <LoadingCard loading={loading} heightSize='80vh' />;
  }

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Amudaryo (jami)</h4>
            </div>

            {data ? (
              <PieChart2 d1={data["f"]["1"]} d2={data["f"]["2"]} />
            ) : null}
          </div>
        </div>
        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Tuyamo’yin SO gacha</h4>
            </div>

            {data ? (
              <PieChart2 d1={data["f"]["3"]} d2={data["f"]["4"]} />
            ) : null}
          </div>
        </div>

        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Tuyamo’yin SO quyi qismi</h4>
            </div>

            {data ? (
              <PieChart2 d1={data["f"]["5"]} d2={data["f"]["6"]} />
            ) : null}
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-4'>
          <div
            className='pie-box _pie-box barchart-box'
            style={{ height: "350px" }}>
            <div className='zarafshon-chart-table mb-2'>
              <h4>Jami juv</h4>
            </div>
            {data ? <BarChart5 arr={data["v"]} /> : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;

const check = (v) => {
  if (!v || typeof v == "undefined") {
    return 0;
  }
};
